import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SectionCta } from './SectionCta';
export function GuaranteeSection() {
  return <section className="w-full bg-sand px-5 py-14 sm:px-6 sm:py-20" data-id="element-143" data-mp="4vry1r9ge1np">
      <div className="mx-auto max-w-2xl" data-id="element-144" data-mp="9u37i0vu6a5e">
        <div className="rounded-2xl border-2 border-gold bg-white p-6 text-center sm:p-9" data-id="element-145" data-mp="9wfpuf5iamiz">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-navy" data-id="element-146" data-mp="eur0ut7jf32s">
            <ShieldCheckIcon className="h-7 w-7 text-gold-light" aria-hidden="true" data-id="element-147" data-mp="jsafvvc27jvs" />
          </span>
          <h2 className="mt-5 font-serif text-[26px] font-bold leading-tight text-navy sm:text-[32px]" data-id="element-148" data-mp="ns1c4ekcus7p">
            7-day satisfaction guarantee
          </h2>
          <p className="mt-4 text-[15.5px] leading-relaxed text-navy/75" data-id="element-149" data-mp="xivx7flv7lrk">
            Explore the system. Review the decision pathways. Open the tools. See whether Menopause
            Decision Desk™ fits the way you work.
          </p>
          <p className="mt-3 text-[15.5px] leading-relaxed text-navy/75" data-id="element-150" data-mp="17g0o1sqno5ep">
            If within the first 7 days you decide it isn’t right for you, request a refund according to the
            guarantee terms. Try it without the long-term commitment.
          </p>
        </div>

        <SectionCta headline="Try the whole system for 7 days with nothing to lose." label="Yes, I want to try it" data-id="element-151" data-mp="1vu9d5u0dpgf8" />
      </div>
    </section>;
}